import Lottie from "lottie-react";
import animationData from "../../constant/animations/thinkingOfSomething.json";
import Image from "next/image";

interface EmptySectionProps {}

const EmptySection: React.FC<EmptySectionProps> = () => {
  const style = {
    maxHeight: "600px",
    maxWidth: "600px",
    marginTop: "-5rem",
    marginLeft: "auto",
    marginRight: "auto",
    opacity: "50%",
  };
  return (
    <div className="font-Inter flex flex-col items-center justify-center min-h-full w-full max-w-lg mx-auto rounded-xl">
      {/* <Image
        src="/SOPwriter/MenInYellowSuit.png"
        height={200}
        width={200}
        className="py-10 -mt-14"
        alt="MenInYellowSuit"
      /> */}
      <p className=" text-center text-tootler-grey-900 font-bold text-2xl">
        Click on the generate button to see the outputs here
      </p>
      <p className="text-center text-tootler-grey-400 mt-3">
        After you have generated a section by filling up the inputs on the left
        you can see the results here
      </p>
    </div>
  );
};

export default EmptySection;
